import {useEffect, useRef, useState} from "react";
import logoImg from "../../assets/images/icomsys_logo.png";
import avatarImg from "../../assets/images/icon-avatar.svg";
import {useNavigate} from "react-router-dom";
import {getTokenAsync, updateTokenAsync, parseJwt} from "../../utils/tokenManage";
import alertUtils from "../../utils/utils";

const getLastServiceGroup = () => localStorage.getItem("lastServiceGroup") || "";
const setLastServiceGroup = (serviceGroup) =>
    localStorage.setItem("lastServiceGroup", serviceGroup);

const getCustLogo = async (serviceGroup) => {
    if (!serviceGroup) {
        await alertUtils.error("메인 그룹 코드 오류");
        return logoImg;
    }

    try {
        const authToken = await getTokenAsync();

        const response = await fetch(
            `${(window.__env__?.REACT_APP_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL)}/api/v1/admin/common/system/serviceGroup/logo/${serviceGroup}`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": authToken
                }
            }
        );

        if (!response.ok) {
            throw new Error("로고 조회 실패");
        }

        const data = await response.json();

        console.log(data);

        if (!data.serviceLogo || data.serviceLogo === "/files/") {
            console.log(logoImg);
            return logoImg;
        }
        return data.serviceLogo;

    } catch (e) {
        console.error(e);
        return logoImg;
    }
};

function Header({ isSidebarOpen, onMenuToggle, onServiceGroupChange, userSeq }) {
    const [companyList, setCompanyList] = useState([]);
    const [currentCompany, setCurrentCompany] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const [userMenuOpen, setUserMenuOpen] = useState(false);
    const [custLogo, setCustLogo] = useState(null);
    const [userInfo, setUserInfo] = useState({
        userName: "",
        userInitial: "U",
        userSeq: "",
        roleVal: "",
        userId: "",
        softphoneAgent: ""
    });

    const userMenuRef = useRef(null);
    const selectRef = useRef(null);
    const navigate = useNavigate();

    const handleMenuClick = () => {
        onMenuToggle && onMenuToggle();
    };

    useEffect(() => {
        getMainOpr();
        getUserInfo();
    }, []);

    useEffect(() => {
        const initLogo = async () => {
            const serviceGroup = getLastServiceGroup();

            if (!serviceGroup) return;

            const logoPath = await getCustLogo(serviceGroup);
            setCustLogo(logoPath);
        };

        initLogo();
    }, []);

    useEffect(() => {
        const clickOutside = (event) => {
            if (selectRef.current && !selectRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
            if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
                setUserMenuOpen(false);
            }
        };

        document.addEventListener("mousedown", clickOutside);
        return () => {
            document.removeEventListener("mousedown", clickOutside);
        };
    }, []);

    const getUserInfo = async () => {
        try {
            const authToken = await getTokenAsync();

            const response = await fetch(
                `${(window.__env__?.REACT_APP_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL)}/api/v1/token/main/uv`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": authToken
                    },
                    credentials: "include"
                }
            );

            if (!response.ok) {
                throw new Error("유저 정보 조회 실패");
            }

            const data = await response.json();

            if (data?.lastUseServiceGroup) {
                localStorage.setItem("lastServiceGroup", data.lastUseServiceGroup);
            }

            setUserInfo({
                userName: data?.userName || "사용자",
                userSeq: data?.userSeq || "",
                roleVal: data?.roleVal || "",
                userId: data?.userId || "",
                softphoneAgent: data?.softphoneAgent || ""
            });
        } catch (error) {
            console.error("유저 정보 조회 오류:", error);
            navigate("/", { replace: true });
        }
    };

    const handleLogout = async () => {
        try {
            const authToken = await getTokenAsync();

            if (window.isSoftPhoneLoading && typeof window.callZettaCheckout === "function") {
                window.callZettaCheckout();
            }

            const payload = parseJwt(authToken.replace(/^Bearer\s+/, ""));
            const userVo = JSON.parse(payload.UserVO);

            const response = await fetch(
                `${(window.__env__?.REACT_APP_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL)}/api/v1/login/logout`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": authToken
                    },
                    credentials: "include",
                    body: JSON.stringify({
                        userGuid: userVo.userGuid,
                        userSeq: userInfo?.userSeq || ""
                    })
                }
            );

            if (!response.ok) {
                throw new Error("로그아웃 실패");
            }
        } catch (error) {
            console.error("로그아웃 오류:", error);
        } finally {
            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");
            localStorage.removeItem("lastServiceGroup");
            sessionStorage.clear();
            document.cookie = "accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

            navigate("/", { replace: true });
        }
    };

    const getMainOpr = async () => {
        const authToken = await getTokenAsync();

        try {
            const response = await fetch(
                `${(window.__env__?.REACT_APP_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL)}/api/v1/token/main/oprmng`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: authToken,
                    },
                    credentials: "include",
                }
            );

            if (!response.ok) {
                throw new Error("고객사 목록 조회 실패");
            }

            const data = await response.json();
            const lastServiceGroup = getLastServiceGroup();

            setCompanyList(data);

            if (data && data.length > 0) {
                const selected =
                    data.find((e) => e.serviceGroup === lastServiceGroup) || data[0];

                setCurrentCompany(selected);
            }
        } catch (error) {
            console.error("getMainOpr error:", error);
        }
    };

    const getMainOprUpdate = async (payload) => {
        const authToken = await getTokenAsync();

        const response = await fetch(
            `${(window.__env__?.REACT_APP_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL)}/api/v1/token/menu/main/oprmng/update`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: authToken,
                },
                credentials: "include",
                body: JSON.stringify(payload),
            }
        );

        if (!response.ok) {
            throw new Error("서비스 그룹 변경 실패");
        }

        return response.json();
    };

    const serviceGroupSelect = async (company) => {
        const payload = {
            serviceGroup: company.serviceGroup,
            userSeq: userInfo?.userSeq || ""
        };

        try {
            setMenuOpen(false);

            // 로고 변경 필요 시 사용
            getCustLogo(company.serviceGroup);

            // 1. 서버 세션/메뉴 기준 서비스그룹 변경
            await getMainOprUpdate(payload);

            // 2. localStorage 저장
            setLastServiceGroup(company.serviceGroup);
            localStorage.setItem("mainServiceGroup", company.serviceGroup);

            // 3. 현재 선택 UI 반영
            setCurrentCompany(company);

            const logoPath = await getCustLogo(company.serviceGroup);
            setCustLogo(logoPath);

            // 4. 토큰 갱신
            await updateTokenAsync(company.serviceGroup);

            // 5. 권한 재조회
            await getTokenAuthList();

            if (onServiceGroupChange) {
                onServiceGroupChange(company.serviceGroup);
            }
        } catch (error) {
            console.error("getMainOprUpdate error:", error);
        }
    };

    async function getTokenAuthList(setAuthList, setPageData) {
        const authToken = await getTokenAsync();
        try {
            const response = await fetch(`${(window.__env__?.REACT_APP_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL)}/api/v1/token/authlist`, {
                method: "GET",
                headers: {
                    "Authorization": authToken,
                    "Content-Type": "application/json; charset=UTF-8"
                }
            });

            if (!response.ok) {
                new Error(`HTTP error! status: ${response.status}`);
            }

            return await response.json();
        } catch (error) {
            console.error("getTokenAuthList error:", error);
            setPageData(null);
            navigate("/");
            return [];
        }
    }

    return (
        <header className="topbar">
            <button
                className={`icon-btn ${isSidebarOpen ? "open" : ""}`}
                id="menuToggle"
                aria-label={isSidebarOpen ? "메뉴 닫기" : "메뉴 열기"}
                type="button"
                onClick={handleMenuClick}
            >
                <span className="hamburger"></span>
            </button>

            <div className="brand-tapbar">
                <div className="brand">
                    {custLogo && (
                        <img src={custLogo} alt="logo" />
                    )}
                </div>

                <div className="brand-secondary">
                    <div
                        ref={selectRef}
                        className={`company-select ${menuOpen ? "open" : ""}`}
                    >
                        <button
                            className="company-select-trigger"
                            type="button"
                            aria-haspopup="listbox"
                            aria-expanded={menuOpen}
                            onClick={() => setMenuOpen((prev) => !prev)}
                        >
                        <span className="company-select-text">
                            {currentCompany?.serviceGroupName || "선택"}
                        </span>

                            <span
                                className="company-select-caret"
                                aria-hidden="true"
                            >
                            </span>
                        </button>

                        {menuOpen && (
                            <div className="company-select-menu" role="listbox">
                                {companyList.map((company) => (
                                    <div
                                        key={company.serviceGroup}
                                        className="company-select-option"
                                        role="option"
                                        onClick={() => serviceGroupSelect(company)}
                                    >
                        <span className="company-select-option-text">
                            {company.serviceGroupName}
                        </span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <div
                        ref={userMenuRef}
                        className={`user-select ${userMenuOpen ? "open" : ""}`}
                    >
                        <button
                            type="button"
                            className="user-select-trigger"
                            aria-haspopup="listbox"
                            aria-expanded={userMenuOpen}
                            onClick={() => setUserMenuOpen((prev) => !prev)}
                        >
                            <span className="user-select-avatar">
                                <img src={avatarImg} alt=""/>
                            </span>

                            <span className="user-select-caret" aria-hidden="true"></span>
                        </button>

                        {userMenuOpen && (
                            <div className="user-select-menu" role="listbox">
                                <button
                                    type="button"
                                    className="user-select-option logout-btn"
                                    onClick={handleLogout}
                                >
                                    로그아웃
                                </button>

                                <button
                                    type="button"
                                    className="user-select-option logout-btn"
                                    onClick={() => navigate("/passwordChange", {
                                        state: { userId: userInfo.userId }
                                    })}
                                >
                                    비밀번호 변경
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                {/*<div className="top-title">
                    <span className="title-icon">🔒</span>
                    <span className="title-text">
                        {currentCompany?.serviceGroupName || ""}
                    </span>
                    <span className="title-caret">
                        <i className="icon-w-arrow"></i>
                    </span>
                </div>*/}
            </div>
        </header>
    );
}

export default Header;